import { PageHeader } from "@/components/common";

export default function PageFrame({ title, subtitle, sourceLabel, children, actions = null, testId }) {
  return (
    <div className="fade-up" data-testid={testId}>
      <PageHeader title={title} subtitle={subtitle}>
        {sourceLabel ? (
          <span className="rounded-full border border-sm-primary/15 bg-sm-primary/[0.05] px-3 py-1.5 text-[10px] font-bold uppercase tracking-[0.08em] text-sm-primary">
            {sourceLabel}
          </span>
        ) : null}
        {actions}
      </PageHeader>
      {children}
    </div>
  );
}
